export * from './window.reference';
